import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/axiosInstance";

// API Thunk
export const fetchCoachSettings = createAsyncThunk(
  "coachSettings/fetchCoachSettings",
  async ({ coachId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/Settings/GetCoachSettings/${coachId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// API Thunk
export const updateCoachSettings = createAsyncThunk(
  "coachSettings/UpsertCoachSettings",
  async ({ requestPayload }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axiosInstance.post(
        `/Settings/UpsertCoachSettings`,
        requestPayload
      );
      if (response.status === 200) {
        dispatch(fetchCoachSettings({ coachId: requestPayload.coachId }));
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data ||
          error.message ||
          "Something went wrong while updating."
      );
    }
  }
);

// Initial State
const initialState = {
  settings: {
    emailNotification: {
      clientSendYouMessage: false,
      clientUpdatedTheirProgress: false,
      youHaveNewLead: false,
    },
    measurementSystem: "",
    mealPlanSetting: {
      defaultMealPlan: "",
      displayRecipeInGredientIn: "",
    },
    isStripeConnected: false,
    oldChatsThreshold: "",
    clientHandling: {
      automaticReminderBirthday: false,
      autoRevokeClientMobileAppAccess: false,
      weightProgressInApp: false,
    },
    checkIns: false,
    sendRemindersToClient: false,
    sendCheckinReminderEvery: {
      unit: null,
      occur: null,
      on: null,
    },
    remindClientVia: {
      pushNotification: false,
      chatMessages: false,
      email: false,
    },
  },
  loading: false,
  error: null,
  success: null,
};

// Redux Slice
const coachSettingsSlice = createSlice({
  name: "coachSettings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCoachSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(fetchCoachSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.settings = action.payload;
        state.success = null;
        state.error = null;
      })
      .addCase(fetchCoachSettings.rejected, (state, action) => {
        state.loading = true;
        state.error = action.payload || "Something went wrong.";
      })
      .addCase(updateCoachSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCoachSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.settings = action.payload;
        state.success = action.payload.message;
      })
      .addCase(updateCoachSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong while updating.";
      });
  },
});

// Export Reducer
export default coachSettingsSlice.reducer;
